import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import i18n from './locales/i18n'
import { BASE_URL } from './services/api'
import Ls from './services/ls'
import Echo from 'laravel-echo'

window.axios = axios
window.Ls = Ls
window.i18n = i18n
window._ = require('lodash')

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.baseURL = BASE_URL

window.axios.interceptors.request.use(function (config) {
    // Exécuter ceci avant que la requête soit envoyée
    const AUTH_TOKEN = Ls.get('auth.token')
        if (AUTH_TOKEN) {
            config.headers.Authorization = `Bearer ${AUTH_TOKEN}`
        }
        return config
    }, function (error) {
        // Do something with request error
        return Promise.reject(error)
    })
;

/**
 * Global Axios Response Interceptor
 */
window.axios.interceptors.response.use(undefined, function (err) {
    if (!err.response) {
        window.toastr.error('Network error: Please check your internet connection or wait until servers are back online')
    } else {
        if (err.response.data && (err.response.statusText === 'Unauthorized' || err.response.data === ' Unauthorized.')) {
            window.toastr.error((err.response.data.message) ? err.response.data.message : 'Unauthorized')
            Ls.remove('auth.token')
            Ls.remove('pseudo')
            Ls.remove('orders')
        } else if (err.response.data && err.response.status === 404 && Ls.get('auth.token')) {

        } else if (err.response.data && err.response.status === 403) {

        } else if (err.response.data.errors) {
            // Show a notification per error
            const errors = JSON.parse(JSON.stringify(err.response.data.errors))
            for (const i in errors) {
                window.toastr.error(errors[i])
            }
        } else {
            // Unknown error
            window.toastr.error((err.response.data.message) ? err.response.data.message : 'Unknown error occurred')
        }
    }
    // Do something with request error
    return Promise.reject(err)
})

const AUTH_TOKEN = Ls.get('auth.token')

if(window.io) {
    window.Echo = new Echo({
        host: `${process.env.VUE_APP_LARAVEL_ECHO_HOST}:${process.env.VUE_APP_LARAVEL_ECHO_PORT}`,
        broadcaster: 'socket.io',
        authEndpoint: `/broadcasting/auth`,
        auth: {
            headers: {
                Authorization: `Bearer ${AUTH_TOKEN}`,
                'user-session-token': AUTH_TOKEN,
                'product': 'adminapp',
                'app-hostname': window.location.hostname
            }
        }
    });
}



    createApp(App)
    .use(store)
    .use(VueAxios, axios)
    .use(router)
    .use(i18n)
    .mount('#app')
